exports = module.exports = require("./../../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#footerTemp{font-family:Avenir,Helvetica,Arial,sans-serif;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-align:center;color:#2c3e50;margin-top:60px}h1,h2{font-weight:400}ul{list-style-type:none;padding:0}li{display:inline-block;margin:0 10px}#author,a{color:#42b983}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2f2fa5fc!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/footerTemp.vue
// module id = 34
// module chunks = 2